/*
 * @Author: 小周
 * @Date: 2023-09-06 16:51:04
 * @LastEditTime: 2024-07-26 10:02:39
 * @LastEditors: MrZHLF
 * @Description: about
 */

import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import styles from './index.module.scss'
import { getList } from './../../api/index'
import { setTimeStamp } from './../../utils/timer'
import { coverImage } from './../../utils/index'
import { PullRefresh, List } from 'react-vant'
const AboutPage = () => {
  const [newsData, setNewsData] = useState([])
  const [finished, setFinished] = useState(false)
  const [pageNo, setPageNo] = useState({
    pageNo: 1,
    pageSize: 10,
  })

  const nav = useNavigate()

  // const getNewsList = (isRefresh) => {
  //   getList({
  //     channelId: '1428654018321252354',
  //     ...pageNo,
  //   }).then((res) => {
  //     if (res.code == 0) {
  //       let data = res.result
  //       if (data.content && data.content.length > 0) {
  //         if (data.pageNo >= data.totalPage) {
  //           setFinished(true)
  //         } else {
  //           setPageNo({
  //             pageNo: isRefresh ? 1 : Number(data.pageNo) + 1,
  //             pageSize: 10,
  //           })
  //           setFinished(false)
  //         }
  //         let tableData = isRefresh
  //           ? data.content
  //           : newsData.concat(data.content)
  //         setNewsData(tableData)
  //       } else {
  //         setFinished(true)
  //       }
  //     }
  //   })
  // }

  const getNewsList = (
    isRefresh,
    pageNoValue = pageNo.pageNo,
    newsDataValue = newsData
  ) => {
    try {
      getList({
        channelId: '1782955154454675457',
        pageNo: isRefresh ? 1 : pageNoValue,
        pageSize: pageNo.pageSize,
      }).then((res) => {
        if (res.code === 0) {
          const data = res.result
          if (data && data.content) {
            if (data.pageNo >= data.totalPage) {
              setFinished(true)
            } else {
              setPageNo((prev) => ({
                pageNo: prev.pageNo + 1,
                pageSize: prev.pageSize,
              }))
              setFinished(false)
            }
            const tableData = isRefresh
              ? data.content
              : [...newsDataValue, ...data.content]
            setNewsData(tableData)
          } else {
            setFinished(true)
          }
        }
      })
    } catch (error) {
      console.error('Failed to get news list:', error)
      // 可以在这里添加用户友好的错误反馈逻辑
    }
  }

  const onRefresh = () => {
    setFinished(false)
    setPageNo({ pageNo: 1, pageSize: 10 })
    getNewsList(true)
  }

  const onLoadData = () => {
    getNewsList(false)
  }

  const handleClickDetail = (item) => {
    nav('/detail/' + item.id)
  }

  const ElemNewsList = () => {
    return newsData && newsData.length > 0 ? (
      newsData.map((item) => {
        return (
          <div
            className={styles.list}
            key={item.id}
            onClick={() => handleClickDetail(item)}
          >
            <div className={styles.item}>
              <img className={styles.cover} src={coverImage(item)} alt="" />
            </div>
            <div className={styles['news_desc']}>
              <p className={styles.title}>{item.title}</p>
              <div className={styles.desc}>
                <div className={styles.left}>
                  <span>{item.articleOrigin}</span>
                  <span className={styles.line}></span>
                  <span>{setTimeStamp(item.publishDate)}</span>
                </div>
                <div className={styles.right}>
                  <img
                    className={styles.icon}
                    src={require('./../../assets/images/comment.png')}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        )
      })
    ) : (
      <span>暂无数据</span>
    )
  }

  return (
    <div className={styles.news}>
      <div className={styles['news-list']}>
        <PullRefresh onRefresh={onRefresh}>
          <List
            finished={finished}
            onLoad={onLoadData}
            finishedText="数据加载完毕"
          >
            {ElemNewsList()}
          </List>
        </PullRefresh>
      </div>
    </div>
  )
}

export default AboutPage
